/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StyledBox, StyledTitle } from '../../styled';
import { BitrateCharts } from './BitrateCharts';

interface ICallQualityProps {
  audioBitrates?: number[];
  videoBitrates?: number[];
}

export default function CallQuality({
  audioBitrates,
  videoBitrates,
}: ICallQualityProps) {
  return (
    <StyledBox mt={3}>
      <StyledTitle variant="h2">Call Quality Indicator</StyledTitle>
      {audioBitrates && videoBitrates ? (
        <BitrateCharts
          audioBitrate={audioBitrates}
          videoBitrate={videoBitrates}
        />
      ) : null}
    </StyledBox>
  );
}
